import request from '@/utils/request.js'
// 获取用户收藏列表
export const getUserLikeList = data => {
  return request({
    method: 'POST',
    url: '/api/yalimedia.fav/index',
    data
  })
}
